import { render, staticRenderFns } from "./ReviewerSelectForm.vue?vue&type=template&id=8ab5a166&scoped=true"
import script from "./ReviewerSelectForm.vue?vue&type=script&lang=js"
export * from "./ReviewerSelectForm.vue?vue&type=script&lang=js"
import style0 from "./ReviewerSelectForm.vue?vue&type=style&index=0&id=8ab5a166&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab5a166",
  null
  
)

export default component.exports